module.exports = "<div class=\"loader-wrapper\">\r\n  <div style=\"margin:auto auto;\">\r\n    <img src=\"assets/images/page-loader.gif\" alt=\"loader\">\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/loader/loader.component.html
// module id = ../../../../../src/app/directive/loader/loader.component.html
// module chunks = main